import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "./comparison-matrix.templates";

export default {
    title: "Components/Comparison Matrix",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-comparison-matrix",
    argTypes: {
        firstColumnWidth: {
            control: {
                type: "number",
            },
        },
    },
    args: {
        firstColumnWidth: 180,
    },
};

export const Default = {};
